import { render } from "./Dots.vue?vue&type=template&id=4e8e179c&scoped=true"
import script from "./Dots.vue?vue&type=script&lang=js"
export * from "./Dots.vue?vue&type=script&lang=js"

import "./Dots.vue?vue&type=style&index=0&id=4e8e179c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8e179c"]])

export default __exports__